/* This is used to normalize between comparable field type plus unit combinations
and these eventually feed into the outcome type dropdrown in the UI */
const MORTALITY_SENSE = 'SUE-_S'
export function getUnitType(row: any, normalizeGeneric?: boolean) {
	if (!row)
		return 'None'
	let type = row.type
	if (type == '% Change')
		return type
	let unit = row.unit
	if (unit == 'PPY')
		return 'Incidence (PPY)'
	if (isBinary(row))
		return '%'
	if (type == 'Count')
		type = 'Incidence'
	if (unit?.match(/unit|score|point/i))
		unit = 'units'
	if (type == 'Incidence' && !unit)
		unit = 'PPY'
	if (type == 'Continuous')
		type = 'Average'
	return type + (unit && unit != type ? ' (' + unit +')' : '')
}
export function isBinary(row) {
	let type = row.type
	if (type == '% Change')
		return false
	if (type == 'Binary' || row.dataType == 'Percentage' || row.dataType == 'Ratio' ||
			((type == 'Number' || type == 'Continuous') && row.unit == '%') ||
			(type == 'Number' || type == 'Count') && row.termIds?.some(ids => ids.includes(MORTALITY_SENSE))) {
		return true
	}
	return false
}
export function getGeneralTypes(row) {
	let type = row.type
	if (type == '% Change')
		return [ type ]
	if (isBinary(row)) {
		let types = [ 'Binary' ]
		if (row.time?.days)
			types.push('Incidence') // can be computed
		if (!types.includes(type))
			types.push(type) // allow original type too
		return types
	}
	if (type == 'Count')
		return [ 'Incidence' ]
	return [ type ]
}
